/**
 * Team color palette for match flow views.
 *
 * Assigns deterministic colors to teams so they are
 * visually distinct across all flow nodes and match views.
 */

export type TeamColor = {
  ring: string;
  bg: string;
  text: string;
  border: string;
  accent: string; // solid bg for accent bars / indicators
};

const TEAM_COLORS: TeamColor[] = [
  {
    ring: "ring-red-400/50",
    bg: "bg-red-500/10",
    text: "text-red-400",
    border: "border-red-400/30",
    accent: "bg-red-400",
  },
  {
    ring: "ring-blue-400/50",
    bg: "bg-blue-500/10",
    text: "text-blue-400",
    border: "border-blue-400/30",
    accent: "bg-blue-400",
  },
  {
    ring: "ring-amber-400/50",
    bg: "bg-amber-500/10",
    text: "text-amber-400",
    border: "border-amber-400/30",
    accent: "bg-amber-400",
  },
  {
    ring: "ring-violet-400/50",
    bg: "bg-violet-500/10",
    text: "text-violet-400",
    border: "border-violet-400/30",
    accent: "bg-violet-400",
  },
  {
    ring: "ring-emerald-400/50",
    bg: "bg-emerald-500/10",
    text: "text-emerald-400",
    border: "border-emerald-400/30",
    accent: "bg-emerald-400",
  },
  {
    ring: "ring-orange-400/50",
    bg: "bg-orange-500/10",
    text: "text-orange-400",
    border: "border-orange-400/30",
    accent: "bg-orange-400",
  },
  {
    ring: "ring-pink-400/50",
    bg: "bg-pink-500/10",
    text: "text-pink-400",
    border: "border-pink-400/30",
    accent: "bg-pink-400",
  },
  {
    ring: "ring-lime-400/50",
    bg: "bg-lime-500/10",
    text: "text-lime-400",
    border: "border-lime-400/30",
    accent: "bg-lime-400",
  },
];

const MY_TEAM_COLOR: TeamColor = {
  ring: "ring-brand-500/50",
  bg: "bg-brand-500/10",
  text: "text-brand-400",
  border: "border-brand-500/30",
  accent: "bg-brand-500",
};

/**
 * Get the color for a given team number.
 *
 * - Current player's team -> brand teal
 * - Other teams -> deterministic color from palette (0-indexed)
 *
 * Team numbers are 0-indexed.
 */
export function getTeamColor(teamNum: number, myTeam?: number): TeamColor {
  if (myTeam != null && teamNum === myTeam) return MY_TEAM_COLOR;
  const idx = ((teamNum % TEAM_COLORS.length) + TEAM_COLORS.length) % TEAM_COLORS.length;
  return TEAM_COLORS[idx];
}
